import { getCookies } from '@gumtree/shared/src/util/cookie-service';
import { CustomPurposeConsentNames, isCustomPurposeConsented } from '../gdpr/util';

export default async function initMicrosoftClarity(window: Window) {
    // Clarity snippet is now injected server-side in HTML. Client should only handle consent.

    // After init, determine consent and signal to Clarity
    const cookie = getCookies(decodeURIComponent(window.document.cookie));
    const isGdprConsented = isCustomPurposeConsented(
        cookie.OptanonConsent,
        CustomPurposeConsentNames.MicrosoftClarity,
    );
    console.log('isGdprConsented------', isGdprConsented);

    const winWithClarity = window as Window & { clarity?: (...args: any[]) => void };
    // Poll up to 3 times for clarity before sending consent
    let attempts = 0;
    const trySendConsent = () => {
        attempts += 1;
        if (typeof winWithClarity.clarity === 'function') {
            // console.log('winWithClarity.clarity------', isGdprConsented);
            winWithClarity.clarity('consent', isGdprConsented);
        } else if (attempts < 3) {
            window.setTimeout(trySendConsent, 200);
        }
    };
    trySendConsent();
}
